import { Box } from '@mui/material';

function GrafanaPanel({ url, title }) {
  if (!title || !url) return null;

  return (
    <Box
      id={`grafanaPanel_${title}`}
      style={{ height: 'calc( 100vh - 140px)' }}>
      <iframe
        title="application-panel"
        src={url}
        style={{
          border: '0px',
          width: '-webkit-fill-available',
          height: '100%',
          display: 'block',
        }}
      />
    </Box>
  );
}

export default GrafanaPanel;
